module.exports = __webpack_public_path__ + "img/tutorial_query-1.64e97163.png";